"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AddChannel = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.8196399,9 L15.7703406,9 L15.3627722,6.0999999 L4.05086384,7.68978494 L5.41729065,17.4124169 L7,17.1899816 L7,18.2871135 L5.53102862,18.4935639 C4.98411867,18.5704271 4.47845063,18.1893789 4.40158745,17.642469 L3.00985644,7.73978827 C2.93299326,7.19287832 3.31404146,6.68721028 3.86095141,6.6103471 L15.2490342,5.00985644 C15.7959442,4.93299326 16.3016122,5.31404146 16.3784754,5.86095141 L16.8196399,9 L16.8196399,9 Z M8,9 L19,9 C19.5522847,9 20,9.44771525 20,10 L20,19 C20,19.5522847 19.5522847,20 19,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,10 C7,9.44771525 7.44771525,9 8,9 Z M8,10 L8,19 L19,19 L19,10 L8,10 Z M11,12.5 C11,12.128309 11.3911563,11.8865611 11.7236068,12.0527864 L15.7236068,14.0527864 C16.0921311,14.2370485 16.0921311,14.7629515 15.7236068,14.9472136 L11.7236068,16.9472136 C11.3911563,17.1134389 11,16.871691 11,16.5 L11,12.5 Z M12,15.690983 L14.381966,14.5 L12,13.309017 L12,15.690983 Z" })));
};
AddChannel.displayName = 'AddChannel';
exports.default = AddChannel;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AddChannel.js.map